var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoToHomePageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.005,
    height: 19.205,
    viewBox: "0 0 19.005 19.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.c{fill:none;}.c{stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-938.378 -578.637)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(927 551.334)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M68.017,99.107a.167.167,0,0,0-.23,0l-3.835,3.663a.167.167,0,0,0-.051.121v3.438a.667.667,0,0,0,.667.667h2a.333.333,0,0,0,.333-.333V103.83a.167.167,0,0,1,.167-.167h1.666a.167.167,0,0,1,.167.167v2.833a.333.333,0,0,0,.333.333h2a.667.667,0,0,0,.667-.667v-3.438a.167.167,0,0,0-.051-.121Z",
    transform: "translate(-46.903 -65.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.892,36.419l-1.558-1.491V32.667A.333.333,0,0,0,24,32.333H23a.333.333,0,0,0-.333.333v.667L21.461,32.18a.683.683,0,0,0-.923,0l-4.431,4.239a.34.34,0,0,0-.028.466.333.333,0,0,0,.483.022l4.322-4.13a.167.167,0,0,1,.23,0l4.323,4.13a.333.333,0,0,0,.471-.009A.342.342,0,0,0,25.892,36.419Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(939 579)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 16,
    height: 16,
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 16,
    height: 16,
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.536 15.865) rotate(172)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.238,12.135l-.854.994A7.765,7.765,0,1,1,15.09,5.177",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.371,2.156V.273A.269.269,0,0,0,2.105,0H.267A.273.273,0,0,0,.078.465L1.917,2.349A.265.265,0,0,0,2.371,2.156Z",
    transform: "translate(13.102 11.046)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToHomePageIcon);
export default __webpack_public_path__ + "static/media/go-to-home-page-icon.7c9d66fa897a712006a70b305eaff844.svg";
export { ForwardRef as ReactComponent };